import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import "../../styles/style.css";
import HeaderFunctions from "../HeaderFunctions/HeaderFunctions";
import Sidebar from "./../Datamigration/sidebar";

const Template = () => {
    const navigate = useNavigate();
    const [schemas, setSchemas] = useState([]);
    const [tables, setTables] = useState([]);
    const { loading } = HeaderFunctions();
    const [activeTable, setActiveTable] = useState(null); // Track the clicked <th>

    useEffect(() => {
        const initiaData = async () => {
            try {
                const response = await axios.get('http://208.109.243.219:5001/template', {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
                });
                setSchemas(response.data.schemas);
            } catch (error) {
                console.error('Error fetching Cure MD data:', error);
            }
        };
    
        initiaData();
    }, []);

    const handleView = async (selectedSchema) => {
        setActiveTable(selectedSchema); // Set the clicked <th> as active
        try {
          const response = await axios.get(`http://208.109.243.219:5001/tables?schema=${selectedSchema}`, null,{ //tables?schema=${selectedSchema}`)
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          });
          setTables(response.data.tables)
        } catch (error) {
          console.error('Error fetching Tables data for View:', error);
        }
    };

    const formatColumn = (header) => {
        return header.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
    };
  
    return (
        <>
        <Header loading={loading} />

        <div className="container">
            <nav style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item">
                <Link to="#"></Link>
                </li>
                <li className="breadcrumb-item">
                <Link to="#"></Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page"></li>
            </ol>
            </nav>
        </div>

        <div className="container pb-4">
            <div className="box-bdr-dash">
                <div className="row">
                    <Sidebar/>
                    <div className="col-md-10">
                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                            <span className="pd-overview-count">Template</span>
                            </div>
                            <div className="row">
                                <div className="col-md-2">
                                    <div className="table-data-box table-responsive ">
                                        <table className="table-content borderd-table" >
                                            <thead>
                                            <tr>
                                                <th>Schema</th>
                                            </tr>
                                            {schemas.length > 0 && schemas.map((item, index) => (
                                                <tr key={index}>
                                                    <th onClick={() => handleView(item)} className={activeTable === item ? "active-th" : "link"}
                                                                    style={{ cursor: "pointer" }}> {formatColumn(item)}</th>
                                                </tr>
                                            ))}
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-10">
                                    <div className="table-data-box table-responsive ">
                                        <table className="table-content borderd-table">
                                            <thead>
                                                <tr>
                                                    <th>Tables</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {tables.length > 0 && tables.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{formatColumn(item)}</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};
export default Template;